// Permite mostrar modulo abono por nacimiento
export const SHOW_ABONO_NACIMIENTO = true
export const FECHA_PUESTA_MARCHA = '2024-11-01'